import types from "../index";

function addToCart(item) {
    return {
        type: types.CART_ADD_TO_CART,
        item: item,
    }
}

function removeFromCart(id) {
    return {
        id: id,
        type: types.CART_REMOVE_FROM_CART,
    }
}

export default {
    addToCart,
    removeFromCart,
}